import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import classnames from "classnames";
import { ToggleableMacroDials } from "../global/ProgressDials";
import { ToggleableProgressBar } from "./ToggleableProgressBar";
import { useProgressViews } from "./hooks";
export const useMacroProgressStyles = makeStyles((theme) => createStyles({
    dials: {
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        paddingTop: theme.spacing(),
    },
    macrosProgress: {
        "&:hover": {
            cursor: "pointer",
        },
    },
}));
export const MacrosProgress = ({ currentMacros, targetMacros, className, variant = "lg", disableChangeMode = false, macroProgressViews, sx, }) => {
    const classes = useMacroProgressStyles();
    const { mode, onChangeMode } = useProgressViews({
        macroProgressViews,
        hasTargets: !!targetMacros,
    });
    const handleChangeMode = disableChangeMode ? undefined : onChangeMode;
    if (macroProgressViews === "none") {
        return null;
    }
    return (_jsxs(Box, { className: classnames(classes.macrosProgress, className), sx: sx, children: [_jsx(ToggleableProgressBar, { mode: mode, macros: currentMacros, targetMacros: targetMacros || undefined }), _jsx("div", { className: classes.dials, onClick: handleChangeMode, children: _jsx(ToggleableMacroDials, { mode: mode, variant: variant, macros: currentMacros, targetMacros: targetMacros || undefined }) })] }));
};
//# sourceMappingURL=Progress.js.map